import styled from 'styled-components';
import { Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const StyledAddOnsContainer = styled(Row)`
  background: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
  padding: 24px 16px;
`;

export const StyledLegContainer = styled.div`
  margin-bottom: 40px;
`;
